import { render, staticRenderFns } from "./PublishProductsLayer.vue?vue&type=template&id=c2a69a06&"
import script from "./PublishProductsLayer.vue?vue&type=script&lang=js&"
export * from "./PublishProductsLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports